import type {
  ContentListApiResponse,
  ContentListResponse,
  ContentSummary,
} from 'api/new-analytics/types';

export function resolvePreviewContentSummary(
  data: ContentListApiResponse | ContentListResponse | undefined,
): ContentSummary | undefined {
  if (!data) {
    return undefined;
  }

  if ('data' in data && data.data?.summary) {
    return data.data.summary;
  }

  if ('summary' in data) {
    return data.summary;
  }

  return undefined;
}
